import React, { useRef, useState } from "react";
import Header from "../Components/Header";
import axios from "axios";
import { PACKUPDATE, SERVICES } from "../Configuration/Telecaller_URl";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
    AESEncryption,
    ApiResDecrypt,
    allTrim,
    getSearchParameters,
    nameFirstLetter,
    startTrimString,
} from "../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../Components/SingleSignOnSideBar";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Loader from "../Components/Common/Loader";
import { useEffect } from "react";
import JSZip from "jszip";
import TeleDashboard from "./TeleDashboard";
import PackUpgrade from "./PackUpgrade";

function TelecallerMerge() {
    const [globalModal, setGlobalModal] = useState(false);
    const [modalData, setModalData] = useState("");
    const [updatedData, setUpdatedData] = useState({});
    const [showTable, setShowTable] = useState(false);
    const [packTable, setPackTable] = useState(false)
    const [clientDetailsResponse, setClientDetailsResponse] = useState({});
    const [noData, setNoData] = useState("");
    const [uqId, setUqId] = useState("");
    const [existNumber, setExistNumber] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const [showPackDetails, setShowPackDetails] = useState([]);
    const refPackNo = useRef("");
    const [application, setApplication] = useState(false);
    const updatePackDetail = useRef("");
    const [aadherPan, setAadherPan] = useState(false);
    const [session, setSession] = useState(false);
    const [buttonStatus, setButtonStatus] = useState("edit");
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const userType = localStorage.getItem("userType")?.toLowerCase();
    const dobschema = Yup.object().shape({
        actuallDOB: Yup.string().notRequired(),
        DOB: Yup.string()
            .required("Please Enter Your DOB")
            .notOneOf([Yup.ref("actuallDOB"), null], "DOB already exist"),
    });
    const genderschema = Yup.object().shape({
        actuallGender: Yup.string().notRequired(),
        gender: Yup.string()
            .required("Select Gender")
            .notOneOf([Yup.ref("actuallGender"), null], "Gender already exist"),
    });

    const otpschema = Yup.object().shape({
        OTP: Yup.string().required("Please enter Your OTP"),
    });
    const {
        register: registerOTP,
        handleSubmit: handleOtp,
        formState: { errors: OtpError },
        setValue: setOtpVal,
        getValues: getOTPValues,
        reset: otpReset,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(otpschema),
    });

    const numberchema = Yup.object().shape({
        numberAndRef: Yup.string()
            // .required("Please enter Your Number or RefNo")
            // .matches(
            //     /^[A-Za-z0-9]{10,20}$/,
            //     "Number Or RefNO will be 10 to 20 digits"
            // ),
            // .required("Please enter reference No.*")
            // .matches( /^(?!\d+$)[A-Za-z0-9]{10,20}$/,
            //     "RefNo should be 10 to 20 alphanumeric characters."
            // )
            .when([], {
                is: () => userType == "capital_markets",  // If userType is "Capital market"
                then: Yup.string()
                .required("Please enter mobile number (or) reference No.*")
                .matches(
                        /^[A-Za-z0-9]/,
                        "Number Or RefNO will be 10 to 20 digits"
                    ),
                otherwise: Yup.string()
                .required("Please enter reference No.*")
                  .matches( /^(?!\d+$)[A-Za-z0-9]{10,20}$/,
                        "RefNo should be 10 to 20 alphanumeric characters."
                    )
            })
    });
    const {
        register: regesterNumberInput,
        handleSubmit: handleSubmitNumber,
        formState: { errors: numberError },
        setValue: setNumberVal,
        getValues: getNumberValues,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(numberchema),
    });
    const emailschema = Yup.object().shape({
        actualEmailId: Yup.string()
            .notRequired()
            .transform((value) => value.toUpperCase()),
        email: Yup.string()
            .required("Please Enter Your Email")
            .matches(
                /^\w+([\.-]?\w+)*@[A-Za-z]{1}\w+([\.-]?\w+)*(\.[A-Za-z]{1}\w{1,5})+$/,
                "Plese Input valid Email"
            )
            .notOneOf([Yup.ref("actualEmailId"), null], "Gmail already exist"),
    });
    const {
        register: registerEmail,
        handleSubmit: handleEmail,
        formState: { errors: errorEmail },
        setValue: setEmailId,
        getValues: getEmaiId,
        reset: resetEmailId,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(emailschema),
    });

    const {
        register: registerGender,
        handleSubmit: handleGender,
        formState: { errors: genderError },
        setValue: setGenderVal,
        reset: resetGendar,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(genderschema),
    });
    const {
        register: registerdobName,
        handleSubmit: handleDobName,
        formState: { errors: dobNameError },
        setValue: setDOBVal,
        setError: setDobErr,
        watch: watchDob,
        clearErrors: clearDob,
        reset: resetDob,
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(dobschema),
    });

    const Fatherschema = Yup.object().shape({
        actuallFatherName: Yup.string().notRequired(),
        fatherName: Yup.string()
            .required("Enter Your Father Name")
            .matches(
                /^((\b[A-Za-z]{1,40}\b)\s*){1,6}$/,
                "Please Enter Valid Father Name"
            )
            .notOneOf(
                [Yup.ref("actuallFatherName"), null],
                "Father Name already exist"
            ),
    });

    const {
        register: registerFatherName,
        handleSubmit: handleFatherName,
        formState: { errors: fatherNameError },
        setValue: setFatherName,
        reset: resetFatherName,
    } = useForm({
        resolver: yupResolver(Fatherschema),
    });

    useEffect(() => {
        const db = watchDob("DOB");
        if (db) {
            if (!db.getMinor()) {
                setDobErr("DOB", {
                    type: "custom",
                    message: "Please Enter Valid Date",
                });
            } else {
                clearDob("DOB");
            }
        }
    }, [watchDob("DOB")]);

    useEffect(() => {
        const urlParams = getSearchParameters();
        if (urlParams.mobileref) {
            function isAlphanumeric(str) {
                return str.match(/^[a-zA-Z0-9]+$/) !== null;
            }
            let isANumber = isAlphanumeric(urlParams.mobileref);
            if (!isANumber) {
                toast.error("Invalid search parameter");
            } else {
                setNumberVal("numberAndRef", urlParams.mobileref);
                handleSubmitNumber(showDetails)();
            }
        }
    }, []);

    const storeToken = localStorage.getItem("ssoToken");
    if (storeToken == null) {
        window.location.replace("/");
    }
    const sessionExpired = () => {
        setSession(false);
        localStorage.clear("");
        navigate("/");
    };
    function showDetails(data) {
        localStorage.setItem("teleUserNumber", data.numberAndRef)
        resetDob();
        resetFatherName();
        resetGendar();
        resetEmailId();
        otpReset();
        disableButtonFor3Seconds();
        clientsDetails(data.numberAndRef, true);
    }
    const disableButtonFor3Seconds = () => {
        var apiButton = document.getElementById("apiButton");
        apiButton.disabled = true;
        setTimeout(function () {
            apiButton.disabled = false;
        }, 3000);
    };
    const refNo = (event) => {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
    };

    const EmailOtpValidation = (event) => {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
    };

    const onSubmitEmailOtp = (data) => {
        setOtpVal("OTP", data.OTP);
        setEmailModal(true);
    };

    const emailVerification = async () => {
        let emailverified = {
            emailID: localStorage.getItem("ReqEmail"),
            otp: getOTPValues("OTP"),
            uqId: uqId,
            mobileNo: clientDetailsResponse.mobile,
            userId: localStorage.getItem("userId"),
        };

        let encPayload = AESEncryption(emailverified);
        try {
            const response = await axios.post(
                `${SERVICES.EMAIL_VALIDATED}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let emailverifRes = ApiResDecrypt(data);
            if (emailverifRes.status == 0) {
                if (emailverifRes.data.message == "Otp Validated") {
                    setEmailModal(false);
                    toast.success(emailverifRes.data.message);
                    resetEmailId({ email: "" });
                    otpReset({ OTP: "" });
                    clientsDetails();
                } else {
                    toast.error(emailverifRes.data.message);
                }
            } else {
                toast.error(emailverifRes.message);
                if (emailverifRes.message == "Invalid Otp") {
                    setOtpVal("OTP", "");
                    setEmailModal(false);
                }
            }
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const clientsDetails = async (data, load = false) => {
        if (load) {
            setLoader(true);
            localStorage.removeItem("ReqEmail");
        }
        let clientPayLoad = {
            mobile: data || clientDetailsResponse.mobile,
            userId: localStorage.getItem("userId"),
        };
        let encPayload = AESEncryption(clientPayLoad);
        try {
            const response = await axios.post(
                `${SERVICES.CLIENT_DETAILSV2}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let adminResponse = ApiResDecrypt(data);
            console.log(adminResponse, "adminResponse");
            if (adminResponse?.status === 1) {
                setNoData(adminResponse.message);
                setClientDetailsResponse({})
                setShowTable(false);
                setPackTable(false)
            } else {
                // debugger
                if (adminResponse.data == "Another Telecaller user is working on this application") {
                    setShowTable(false);
                    setPackTable(false)
                    setExistNumber(true);
                    return;
                }
                if (adminResponse.data.leadDetails !== null) {
                    setClientDetailsResponse(adminResponse?.data.leadDetails);
                    setPackTable(false)
                    setShowTable(true);
                    setNoData("");
                    if (adminResponse.data.leadDetails.mobile) {
                        getPackDetails(adminResponse.data.leadDetails.mobile);
                    }
                    setDOBVal("actuallDOB", adminResponse?.data?.leadDetails?.dob.reverseDob());
                    setGenderVal("actuallGender", adminResponse?.data?.leadDetails?.genderView);
                    setFatherName("actuallFatherName", adminResponse?.data?.leadDetails?.fatherName);
                    setEmailId("actualEmailId", adminResponse?.data?.leadDetails?.emailId);
                }
                if (adminResponse.data.packUpgrade !== null) {
                    setClientDetailsResponse(adminResponse?.data.packUpgrade);
                    setShowTable(false);
                    setPackTable(true);
                    setNoData("");

                }
                else {
                    setExistNumber(false);
                }
                // setNoData("");
                // otpReset();
                if (load) {
                    if (adminResponse.data?.leadDetails?.IsAadharPanSeeded == false) {
                        setAadherPan(true);
                    } else {
                        setAadherPan(false);
                    }
                }

            }
        } catch (err) {
            console.log(err);
            setShowTable(false);
            setPackTable(false);
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
                setNoData("Something went wrong");
            }
        } finally {
            setLoader(false);
        }
    };
    console.log(clientDetailsResponse, "ClientDetailsResponse");
    const updateAll = async () => {
        let updateObject = {
            mobile: clientDetailsResponse.mobile,
            gender: clientDetailsResponse.genderView,
            dob: clientDetailsResponse.dob,
            packtype: clientDetailsResponse.packType,
            packpayinfo: clientDetailsResponse.packAmount,
            userName: clientDetailsResponse.cName,
            transRefNo: clientDetailsResponse?.transRefNo || "",
            userId: localStorage.getItem("userId"),
            fatherName: clientDetailsResponse.fatherName,
            ...updatedData,
        };
        console.log(updateObject, "updateObject");
        let encPayload = AESEncryption(updateObject);
        try {
            const response = await axios.post(
                `${SERVICES.UPDATE_DOB_TELECALLER}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let updateDobResReq = ApiResDecrypt(data);
            if (updateDobResReq.status == 0) {
                toast.success(updateDobResReq.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setGlobalModal(false);
                resetDob({ DOB: "" });
                resetFatherName({ fatherName: "" });
                resetGendar({ gender: "" });
                clientsDetails();
            } else {
                toast.error(updateDobResReq.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return;
            }
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const editApplication = async () => {
        let editApp = {
            mobile: clientDetailsResponse.mobile,
            userId: localStorage.getItem("userId"),
            ekycrej: clientDetailsResponse.isRejected == "" ? false : true,
        };
        let encPayload = AESEncryption(editApp);
        try {
            const response = await axios.post(
                `${SERVICES.EDIT_APPLICATION}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let editResponse = ApiResDecrypt(data);
            if (editResponse.data !== "" || editResponse.data !== null) {
                window.open(editResponse.data);
            }
        } catch (err) {
            if (err.request.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const getPackDetails = async (value) => {
        console.log(value);
        let packDetails = {
            userId: localStorage.getItem("userId"),
            mobileno: value || localStorage.getItem("mob"),
        };
        let encPayload = AESEncryption(packDetails);
        try {
            const response = await axios.post(
                `${SERVICES.GET_PACK_DETAILS}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let packDetailsRes = ApiResDecrypt(data);
            if (packDetailsRes !== "" || packDetailsRes !== null) {
                setShowPackDetails(packDetailsRes.data);
            } else {
                setShowPackDetails(packDetailsRes.data.message);
            }
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    //     let PackAmount = "0";
    //     if (transRefnumber === "Free Pack") {
    //         PackAmount = "0";
    //     }
    //     if (transRefnumber === "BPC") {
    //         PackAmount = "9999";
    //     }
    //     if (transRefnumber === "Professional Pack") {
    //         PackAmount = "2500";
    //     }
    //     let updateClient = {
    //         mobile: clientDetailsResponse.mobile,
    //         gender: clientDetailsResponse.genderView,
    //         dob: clientDetailsResponse.dob,
    //         packtype:
    //             updatePackDetail.current.value || clientDetailsResponse.packType,
    //         packpayinfo: PackAmount,
    //         userName: clientDetailsResponse.cName,
    //         transRefNo: transRefnumber == "Free Pack" ? "" : refPackNo.current.value,
    //         userId: localStorage.getItem("userId"),
    //         fatherName: clientDetailsResponse.fatherName,
    //     };

    //     let encPayload = AESEncryption(updateClient);
    //     try {
    //         const response = await axios.post(
    //             `${SERVICES.UPDATE_TELECALLER_DETAILS}`,
    //             encPayload,

    //             {
    //                 headers: {
    //                     "content-Type": "application/json",
    //                     reserv: 1,
    //                     Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
    //                 },
    //             }
    //         );
    //         const data = await response.data;
    //         let updateClientResponse = ApiResDecrypt(data);
    //         if (updateClientResponse.status == 0) {
    //             clientsDetails();
    //             toast.success(updateClientResponse.data.message);
    //             setButtonStatus("edit");
    //         } else {
    //             toast.error(updateClientResponse.message);
    //             setButtonStatus("submit");
    //         }
    //     } catch (err) {
    //         if (err?.request?.status == "401") {
    //             setSession(true);
    //         } else {
    //             setSession(false);
    //         }
    //     }
    // };

    // function onSubmitPackDetails() {
    //     let option = updatePackDetail.current.value;
    //     let refPack = refPackNo.current.value;
    //     if (option === "Free Pack" || (refPack !== "" && option !== "Free Pack")) {
    //         updateClientDetails(option);
    //     }
    //     if (option !== "Free Pack" && refPack == "") {
    //         toast.error("Please Enter Transaction Ref No.");
    //     }
    // }
    // const getSelectPack = (e) => {
    //     if (e.target.value === "" || e.target.value === "Free Pack") {
    //         if (clientDetailsResponse.paymentStatus?.toLowerCase() !== "success") {
    //             refPackNo.current.style.display = "none";
    //             refPackNo.current.value = "";
    //             setButtonStatus("submit");
    //         } else {
    //             refPackNo.current.style.display = "none";
    //             refPackNo.current.value = "";
    //             setButtonStatus("edit");
    //         }
    //     } else {
    //         refPackNo.current.style.display = "block";
    //         setButtonStatus("submit");
    //     }
    // };
    function onSubmitupdateDob(data) {
        setGlobalModal(true);
        setModalData("DOB");
        setUpdatedData({ dob: data.DOB.reverseDob() });
    }
    function onSubmitchangeGender(data) {
        if (data.actuallGender !== "") {
            setGlobalModal(true);
            setModalData("Gender");
            setUpdatedData({ gender: data.gender });
        } else {
            toast.error("error");
        }
    }
    const onSubmitFather = (data) => {
        setGlobalModal(true);
        setModalData("Father Name");
        setUpdatedData({ fatherName: data.fatherName });
    };

    const onSubmitGetOtp = (data) => {
        getEmailOtp(data.email);
    };
    const getEmailOtp = async (email) => {
        let sendEmail = {
            emailId: email,
            customerName: clientDetailsResponse.cName,
            userId: localStorage.getItem("userId"),
            mobileNo: clientDetailsResponse.mobile,
        };
        let encPayload = AESEncryption(sendEmail);
        try {
            const response = await axios.post(
                `${SERVICES.SEND_EMAIL_OTP}`,
                encPayload,

                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let emailotpverifyRes = ApiResDecrypt(data);

            if (emailotpverifyRes.status == 0) {
                toast.success(emailotpverifyRes.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                if (emailotpverifyRes.data.message == "Otp Send Successfully") {
                    setUqId(emailotpverifyRes.data.uqid);
                    localStorage.setItem("ReqEmail", email);
                } else {
                    setUqId("");
                }
            } else {
                setUqId("");
            }
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };


    const sendWpMessage = async () => {
        let messageRequest = {
            mobile: clientDetailsResponse.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            customerName: clientDetailsResponse.cName || "Customer",
        };
        let encPayload = AESEncryption(messageRequest);

        try {
            const response = await axios.post(
                `${SERVICES.WhatsappMSGToClient}`,
                encPayload,
                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );
            const data = await response.data;
            let sendWpMRes = ApiResDecrypt(data);
            if (sendWpMRes.status == 0) {
                if (sendWpMRes.data.msg == "SMS sent successfully") {
                    toast.success(sendWpMRes.data.msg);
                }
                if (sendWpMRes.data.msg == "Max limit reached for sms") {
                    document.getElementById("wpMs").disabled = true;
                    toast.error(sendWpMRes.data.msg);
                } else {
                    document.getElementById("wpMs").disabled = false;
                }
            } else {
                console.log(sendWpMRes, "error");
                toast.error(sendWpMRes.message);
            }
            console.log(data);
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const downloadFiles = async () => {
        let downloadRequest = {
            mobile: clientDetailsResponse.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            pageSize: 0,
            pageNo: 0,
        };

        let encPayload = AESEncryption(downloadRequest);

        try {
            const response = await axios.post(
                `${SERVICES.GetAllDocuments}`,
                encPayload,
                {
                    headers: {
                        "content-Type": "application/json",
                        reserv: 1,
                        Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
                    },
                }
            );

            const { data } = response;
            let downloadWpDocRes = ApiResDecrypt(data);
            if (downloadWpDocRes.status == 1) {
                toast.error(downloadWpDocRes.message);
            }
            const zip = new JSZip();
            const promises = [];
            downloadWpDocRes.data.docList.forEach((doc) => {
                const fileName = doc.docName.split("/").pop();
                promises.push(
                    axios
                        .get(doc.docPath, { responseType: "blob" })
                        .then((downloadWpDocRes) =>
                            zip.file(fileName, downloadWpDocRes.data)
                        )
                );
            });
            Promise.allSettled(promises)
                .then(() => {
                    zip.generateAsync({ type: "blob" }).then((blob) => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "files.zip";
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                })
                .catch((error) => console.error("Error downloading files:", error));
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };
    const maskNumber = (mobile) => {
        let mobileDigit = mobile.split("")
        mobileDigit = mobileDigit.map((digits, index) =>  index < mobileDigit.length - 4 ? '*' : digits);
        return mobileDigit.join("")
      };
    return (
        <>
            <Header portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="telecallerDash">
                <div className="telecaller">
                    <div className="card-box">
                        <div className="title-section">
                            <h2 className="card-title">Lead Dashboard</h2>
                        </div>
                        <div action="" className="">
                            <div className="row telecaller-form">
                                <div className="col-md-4 col-sm-4 col-12">
                                {userType=="capital_markets"?
                                    <div className="form-group">
                                        
                                        <label className="form-label">
                                           Enter Mobile number or Reference No.{" "}
                                            <span className="star_text">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="FromDate"
                                            placeholder=" Enter Mobile number or Reference No."
                                            onInput={(e) => {
                                                allTrim(e);
                                                setNoData("");
                                                setShowTable(false);
                                                setPackTable(false)
                                            }}
                                            {...regesterNumberInput("numberAndRef")}
                                            className={`form-control ${numberError?.numberAndRef ? "is-invalid" : ""
                                                }`}
                                            autoComplete="off"
                                            maxLength={20}
                                        />
                                        <div className="invalid-feedback number-field">
                                            {numberError.numberAndRef?.message}
                                        </div>
                                    </div>
                                    : <div className="form-group">
                                        
                                    <label className="form-label">
                                        Reference No.{" "}
                                        <span className="star_text">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="FromDate"
                                        placeholder="Enter Reference number"
                                        onInput={(e) => {
                                            allTrim(e);
                                            setNoData("");
                                            setShowTable(false);
                                            setPackTable(false)
                                        }}
                                        {...regesterNumberInput("numberAndRef")}
                                        className={`form-control ${numberError?.numberAndRef ? "is-invalid" : ""
                                            }`}
                                        autoComplete="off"
                                        maxLength={20}
                                    />
                                    <div className="invalid-feedback number-field">
                                        {numberError.numberAndRef?.message}
                                    </div>
                                </div>}
                                </div>

                                <div className="col-md-4 col-sm-4 col-12">
                                    <button
                                        value="submit"
                                        className="send-message"
                                        id="apiButton"
                                        onClick={handleSubmitNumber(showDetails)}
                                    >
                                        GET DETAILS
                                    </button>
                                </div>
                            </div>

                            {loader ? (
                                <div className="loader-alignment">
                                    <Loader />
                                </div>
                            ) : (
                                <>
                                    {(noData == "No Data Found" && localStorage.getItem("userType").toLowerCase() == "capital_markets") && <>
                                        <div className="mt-20 d-flex justify-content-between lead-header">
                                            <div className="title-section">
                                                <h2 className="card-title"></h2>
                                            </div>

                                            <div>
                                                <button
                                                    className="send-message"
                                                    onClick={sendWpMessage}
                                                    id="wpMs"
                                                >
                                                    SEND WHATSAPP MESSAGE
                                                </button>
                                                <button
                                                    className="send-message ml-4"
                                                    onClick={downloadFiles}
                                                >
                                                    DOWNLOAD FILES
                                                </button>
                                            </div>

                                        </div>
                                    </>}
                                    {showTable ? (

                                        <div>

                                            {(localStorage.getItem("userType").toLowerCase() ==
                                                "hgs" ||
                                                localStorage.getItem("userType").toLowerCase() ==
                                                "bajaj" ||
                                                localStorage.getItem("userType").toLowerCase() ==
                                                "capital_markets" ||
                                                localStorage.getItem("userType").toLowerCase() ==
                                                "iba" ||
                                                localStorage.getItem("userType").toLowerCase() ==
                                               "dr.itm") ? (
                                                <div className="mt-20 d-flex justify-content-between lead-header">
                                                    <div className="title-section">
                                                        <h2 className="card-title">Lead Details</h2>
                                                    </div>

                                                    <div>
                                                        <button
                                                            className="send-message"
                                                            onClick={sendWpMessage}
                                                            id="wpMs"
                                                        >
                                                            SEND WHATSAPP MESSAGE
                                                        </button>
                                                        <button
                                                            className="send-message ml-4"
                                                            onClick={downloadFiles}
                                                        >
                                                            DOWNLOAD FILES
                                                        </button>
                                                    </div>

                                                </div>
                                            ) : <>
                                                <div className="title-section lead-header">
                                                    <h2 className="card-title">Lead Details</h2>
                                                </div>
                                            </>}

                                            <div className="table-responsive scroll-table telecaller-table-wrapper resume-table ">

                                                <table className="table teletable" id="addher_pan">
                                                    <thead>
                                                        <tr>
                                                            <th>Customer Name</th>
                                                            <th>PAN Number</th>
                                                            <th>Mobile Number</th>
                                                            <th>City</th>
                                                            <th>Created Date</th>
                                                            <th>Last Resume Date</th>
                                                            <th>Lead Source</th>
                                                            <th>Lead Score</th>
                                                            <th>Lead Category</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ height: "unset" }}>
                                                        <tr>
                                                            <td>{clientDetailsResponse.cName}</td>
                                                            <td>{maskNumber(clientDetailsResponse.pan)}</td>
                                                            <td>{maskNumber(clientDetailsResponse.mobile)}</td>
                                                            <td>{clientDetailsResponse.city}</td>
                                                            <td>{clientDetailsResponse.cDate}</td>
                                                            <td>{clientDetailsResponse.resumeDate}</td>
                                                            <td>{clientDetailsResponse.utmSource}</td>
                                                            <td>{clientDetailsResponse.leadScore}</td>

                                                            <td>{clientDetailsResponse.leadCategory}

                                                            </td>
                                                            <td>
                                                                <div className="tele-btn-wrapper">

                                                                    <button
                                                                        className="tele-btn"
                                                                        onClick={editApplication}
                                                                        id="edit_field"
                                                                        disabled={
                                                                            !clientDetailsResponse.isEmailValidated ||
                                                                            !clientDetailsResponse.IsAadharPanSeeded
                                                                        }
                                                                    >
                                                                        Edit Application
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table className="table teletable">
                                                    <thead></thead>
                                                    <tbody style={{ height: "unset" }}>
                                                        <tr
                                                            style={{
                                                                textAlign: "center",
                                                                verticalAlign: "middle",
                                                                padding: "10px",
                                                                fontSize: "14px",
                                                                border: "1px solid #e8e8e8",
                                                            }}
                                                        >
                                                            Application Status :{" "}
                                                            {clientDetailsResponse.isRejected
                                                                ? "Rejected"
                                                                : clientDetailsResponse.applicationStatus}
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                {!clientDetailsResponse.isEmailValidated ? (
                                                    <p className="back-error">Email is not validated</p>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            {clientDetailsResponse.emailId !== "" && (
                                                <div id="email_verify">
                                                    <p className="otp-title">
                                                        Note : Email OTP verification required for new email
                                                        update.
                                                    </p>
                                                    <div className="verification-table">
                                                        <div className="opt-verification-table table-responsive scroll-table">
                                                            <table className="table">
                                                                <tbody style={{ height: "unset" }}>
                                                                    <tr>
                                                                        <td>DOB</td>
                                                                        <td>
                                                                            <div className="">
                                                                                <input
                                                                                    type="date"
                                                                                    readOnly={true}
                                                                                    className={`border-0 datepicker`}
                                                                                    {...registerdobName("actuallDOB")}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="">
                                                                                <input
                                                                                    type="date"
                                                                                    placeholder="dd/mm/yyyy"
                                                                                    className={`datepicker form-control ${dobNameError?.DOB
                                                                                        ? "is-invalid"
                                                                                        : ""
                                                                                        }`}
                                                                                    max={new Date(
                                                                                        new Date().setFullYear(
                                                                                            new Date().getFullYear() - 18
                                                                                        )
                                                                                    ).toLocaleDateString("en-CA")}
                                                                                    min={new Date(
                                                                                        new Date().setFullYear(
                                                                                            new Date().getFullYear() - 90
                                                                                        )
                                                                                    ).toLocaleDateString("en-CA")}
                                                                                    {...registerdobName("DOB")}
                                                                                />
                                                                                <div className="invalid-feedback">
                                                                                    {dobNameError.DOB?.message}
                                                                                </div>
                                                                            </div>
                                                                        </td>

                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="tele-update-btn"
                                                                                onClick={handleDobName(
                                                                                    onSubmitupdateDob
                                                                                )}
                                                                            >
                                                                                UPDATE DOB
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Email</td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="border-0"
                                                                                readOnly
                                                                                {...registerEmail("actualEmailId")}
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <div className="form-group">
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter your new Email"
                                                                                    onInput={(e) => allTrim(e)}
                                                                                    onPaste={(e) => e.preventDefault()}
                                                                                    {...registerEmail("email")}
                                                                                    className={`form-control ${errorEmail?.email
                                                                                        ? "is-invalid"
                                                                                        : ""
                                                                                        }`}
                                                                                />
                                                                                <div className="invalid-feedback">
                                                                                    {errorEmail?.email?.message}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="tele-update-btn"
                                                                                onClick={handleEmail(onSubmitGetOtp)}
                                                                            >
                                                                                GET OTP
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Email OTP</td>
                                                                        <td></td>
                                                                        <td>
                                                                            <div className="form-group">
                                                                                <input
                                                                                    type="text"
                                                                                    id="otp_field"
                                                                                    placeholder="Please enter OTP"
                                                                                    disabled={uqId === ""}
                                                                                    onInput={(e) => {
                                                                                        allTrim(e);
                                                                                        EmailOtpValidation(e);
                                                                                    }}
                                                                                    {...registerOTP("OTP")}
                                                                                    maxLength={4}
                                                                                    className={`form-control ${OtpError?.OTP ? "is-invalid" : ""
                                                                                        }`}
                                                                                />
                                                                                <div className="invalid-feedback">
                                                                                    {OtpError.OTP?.message}
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                className="tele-update-btn"
                                                                                disabled={uqId === ""}
                                                                                onClick={handleOtp(onSubmitEmailOtp)}
                                                                            >
                                                                                UPDATE EMAIL
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Gender</td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                readOnly={true}
                                                                                className={`border-0 datepicker`}
                                                                                {...registerGender("actuallGender")}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <select
                                                                                className={`tele-select form-select ${genderError?.gender
                                                                                    ? "is-invalid"
                                                                                    : ""
                                                                                    }`}
                                                                                {...registerGender("gender")}
                                                                            >
                                                                                <option value="">select</option>
                                                                                <option value="Male" id="male_option">
                                                                                    Male
                                                                                </option>
                                                                                <option
                                                                                    value="Female"
                                                                                    id="female_option"
                                                                                >
                                                                                    Female
                                                                                </option>
                                                                            </select>
                                                                            <div className="invalid-feedback">
                                                                                {genderError.gender?.message}
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                type="submit"
                                                                                className="tele-update-btn"
                                                                                onClick={handleGender(
                                                                                    onSubmitchangeGender
                                                                                )}
                                                                            >
                                                                                UPDATE GENDER
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Father Name</td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className="border-0 "
                                                                                readOnly
                                                                                {...registerFatherName(
                                                                                    "actuallFatherName"
                                                                                )}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <div className="form-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    placeholder="Enter your Father Name"
                                                                                    onInput={(e) => {
                                                                                        nameFirstLetter(e);
                                                                                        startTrimString(e);
                                                                                    }}
                                                                                    {...registerFatherName("fatherName")}
                                                                                />
                                                                            </div>
                                                                            <p className="error_message">
                                                                                {fatherNameError?.fatherName?.message}
                                                                            </p>
                                                                        </td>
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="tele-update-btn"
                                                                                onClick={handleFatherName(
                                                                                    onSubmitFather
                                                                                )}
                                                                            >
                                                                                UPDATE FATHER NAME
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        // <p className="no-data-found">{noData}</p>
                                        <>{packTable ? (
                                            <div>
                                                <PackUpgrade clientDetailsResponse={clientDetailsResponse} />
                                            </div>
                                        ) : (
                                            <p className="no-data-found">{noData}</p>
                                        )}</>
                                    )}


                                </>
                            )}
                        </div>
                        <TeleDashboard />

                    </div>

                </div>

            </main>

            <Modal
                show={emailModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Change Email Address
                    </Modal.Title>
                    <button
                        type="button"
                        onClick={() => setEmailModal(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Are you sure want to Change your Email ID:-({getEmaiId("email")})
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={emailVerification}
                        >
                            Yes
                        </Button>
                        <Button
                            className="no-btn confirmation-btn"
                            closeButton
                            onClick={() => {
                                setEmailModal(false);
                                setOtpVal("OTP", "");
                            }}
                        >
                            No
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={existNumber}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <button
                        type="button"
                        onClick={() => setExistNumber(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Another Telecaller user is working on this application
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => setExistNumber(false)}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={application}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <button
                        type="button"
                        onClick={() => setApplication(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">Application already submitted</h4>
                </Modal.Body>
            </Modal>
            <Modal
                show={aadherPan}
                onHide={() => setAadherPan(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <button
                        type="button"
                        onClick={() => setAadherPan(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        “We regret to inform you that you will not be able to proceed ahead
                        as your PAN is not linked with your Aadhar. As per the new
                        regulatory guidelines it is mandatory to have your PAN linked with
                        Aadhar to carry out any financial transactions.{" "}
                        <a
                            target="_blank"
                            className="link_tag"
                            href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/bl-link-aadhaar"
                            rel="noreferrer"
                        >
                            Click here
                        </a>{" "}
                        to link your PAN with Aadhar now.”
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => setAadherPan(false)}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={session}
                onHide={() => setSession(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                className="popup rm-model session-expired"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {/* Change Gender */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Session has been expired,Please Login again...
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => sessionExpired()}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* new Modal Common */}

            <Modal
                show={globalModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update {modalData}
                    </Modal.Title>
                    <button
                        type="button"
                        onClick={() => setGlobalModal(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Are you sure want to Update {modalData}?
                    </h4>
                    <div className="btn-yes-no">
                        <Button className="yes-btn confirmation-btn" onClick={updateAll}>
                            Yes
                        </Button>
                        <Button
                            className="no-btn confirmation-btn"
                            closeButton
                            onClick={() => setGlobalModal(false)}
                        >
                            No
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default TelecallerMerge;
